import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ReactComponent as EditSvg} from "../assets/svg/edit.svg";
import {ReactComponent as DeleteSvg} from "../assets/svg/trash.svg";
import {MdDragIndicator} from "react-icons/md";
import {useColor} from "../contexts/ColorContext";

interface FieldItemProps {
    className?: string;
    title?: string;
    onValueChange?: (value: string) => void;
    onItemDeleted?: () => void;
    isEditingItem?: boolean;
    dragListeners?: Record<string, any>;
    dragAttributes?: Record<string, any>;
    [key: string]: any;
}

const propTypes = {
    title: PropTypes.string,
    onValueChange: PropTypes.func,
    onItemDeleted: PropTypes.func,
    isEditingItem: PropTypes.bool
}

const defaultProps = {
    title: '',
    onValueChange: ()=>{},
    onItemDeleted: ()=>{},
    isEditingItem: false
}

const FieldItem = ({
    className,
    title,
    isEditingItem,
    onValueChange,
    onItemDeleted,
    dragListeners,
    dragAttributes,
    ...props
}: FieldItemProps) => {
    const {colors} = useColor()
    const [isEditing, setIsEditing] = useState(isEditingItem)
    const [value, setValue] = useState(title);

    useEffect(() => {
        setIsEditing(isEditingItem);
    }, [isEditingItem]);

    useEffect(() => {
        setValue(title);
    }, [title]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        onValueChange?.(event.target.value);
    };
    const handleBlur = () => {
        if (!isEditingItem) setIsEditing(false);
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleBlur();
        }
    };

    return (
        <div className='d-flex align-items-center my-3'>
            {dragListeners && (
                <button
                    className='border-0 bg-transparent p-0 me-1'
                    style={{cursor: 'grab', touchAction: 'none'}}
                    {...dragListeners}
                    {...dragAttributes}
                >
                    <MdDragIndicator size={18} className='hoverable' style={{color: '#999'}}/>
                </button>
            )}
            {
                !isEditing?
                    <div className='font-bold mx-2'>
                        {value ?? title}
                    </div>:
                    <input className='form-control form-control-sm mx-2' style={{width: '40%'}} value={value}
                           onChange={handleChange} onBlur={handleBlur} onKeyDown={handleKeyDown}
                           autoFocus />
            }

            <button className='border-0 bg-transparent' onClick={()=>setIsEditing(!isEditing)}>
                <EditSvg className='hoverable'/>
            </button>

            <button className='border-0 bg-transparent' onClick={()=>onItemDeleted?.()}>
                <DeleteSvg color={colors.error} className='hoverable'/>
            </button>
        </div>
    );
}

FieldItem.propTypes = propTypes;
FieldItem.defaultProps = defaultProps;

export default FieldItem;
